import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  VACANCY_PAGE_ADD_PATH,
  VACANCY_PAGE_PATH,
  VACANCY_PAGE_UPDATE_PATH,
} from "utils/constants/paths";

const VacancyDetailsPage = Loadable(React.lazy(() => import("./View")));
const VacancyDetailsPageAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const VacancyRoute: IRouteItem = {
  path: VACANCY_PAGE_PATH,
  element: React.createElement(VacancyDetailsPage),
  name: "Vacancy Listing",
  children: [
    {
      name: "Add / Update",
      path: VACANCY_PAGE_ADD_PATH,
      element: React.createElement(VacancyDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: VACANCY_PAGE_UPDATE_PATH,
      element: React.createElement(VacancyDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
